module.exports = __webpack_public_path__ + "img/man_on_phone.3e169a94.svg";